document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const toggleButton = document.querySelector('[data-toggle="filters"]')
    const sidebar = document.getElementById("cloud_search_filters_sidebar")
    const productContainer = document.querySelector("#MainContent div.page-collections")
    const toggleButtonMobile = document.querySelector(
      "a.cloud-search-page-controls__filters-link"
    )
    const appliedFilters = document.querySelector(".cloud-search-page-controls__applied-filters")

    if (toggleButton && sidebar) {
      toggleButton.addEventListener("click", () => {
        const isHidden = productContainer.classList.contains("filters-opened")
        !isHidden
          ? productContainer.classList.add("filters-opened")
          : productContainer.classList.remove("filters-opened")
        renameSortsInFilters()
      })
    }

    if (toggleButtonMobile) {
      toggleButtonMobile.addEventListener("click", () => {
        renameSortsInFilters()
      })
    }

    if (appliedFilters) document.querySelector("body").classList.add("search-results-page")

    renameSortsInFilters()
  }, 250)
})

function renameSortsInFilters() {
  const sortLabelsDesktop = document.querySelectorAll(
    '[data-filter-name="Sort by"] .cloud-search-filter-value'
  )

  const labelMap = {
    manual: "Relevance",
    "created-descending": "Newest",
    "best-selling": "Top sellers",
    "price-descending": "Price (High - Low)",
    "price-ascending": "Price (Low - High)",
  }

  sortLabelsDesktop.forEach(label => {
    const value = label.getAttribute("data-filter-value")
    if (labelMap[value]) {
      const nameSpan = label.querySelector(".cloud-search-filter-value__name")
      if (nameSpan) nameSpan.textContent = labelMap[value]
    } else {
      label.style.display = "none"
    }
  })
}

document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".cloud-search-page-controls__applied-filters")

  let isDown = false
  let startX
  let scrollLeft

  if (slider) {
    slider.addEventListener("mousedown", e => {
      isDown = true
      slider.classList.add("dragging")
      startX = e.pageX - slider.offsetLeft
      scrollLeft = slider.scrollLeft
    })

    slider.addEventListener("mouseleave", () => {
      isDown = false
      slider.classList.remove("dragging")
    })

    slider.addEventListener("mouseup", () => {
      isDown = false
      slider.classList.remove("dragging")
    })

    slider.addEventListener("mousemove", e => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - slider.offsetLeft
      const walk = (x - startX) * 1.5 // adjust scroll speed
      slider.scrollLeft = scrollLeft - walk
    })
  }
})
